import React from 'react'
import ServiceTemplate from '../../components/ServiceTemplate'
import { Users, MessageCircle, BookOpen, Award } from 'lucide-react'

const CustomerSupport = () => {
  const features = [
    {
      icon: <Users className="w-6 h-6" data-component-path="client/src/pages/services/CustomerSupport.jsx" data-component-line="7:12" data-component-id="client/src/pages/services/CustomerSupport.jsx:7:12" />,
      title: 'Dedicated Team',
      description: 'Personal support specialists for your project'
    },
    {
      icon: <MessageCircle className="w-6 h-6" data-component-path="client/src/pages/services/CustomerSupport.jsx" data-component-line="13:12" data-component-id="client/src/pages/services/CustomerSupport.jsx:13:12" />,
      title: 'Direct Communication',
      description: 'Multiple channels for instant assistance'
    },
    {
      icon: <BookOpen className="w-6 h-6" data-component-path="client/src/pages/services/CustomerSupport.jsx" data-component-line="19:12" data-component-id="client/src/pages/services/CustomerSupport.jsx:19:12" />,
      title: 'Training Sessions',
      description: 'Comprehensive onboarding for your team'
    },
    {
      icon: <Award className="w-6 h-6" data-component-path="client/src/pages/services/CustomerSupport.jsx" data-component-line="25:12" data-component-id="client/src/pages/services/CustomerSupport.jsx:25:12" />,
      title: 'Quality Guarantee',
      description: 'Commitment to your complete satisfaction'
    },
  ]

  return (
    <ServiceTemplate
      title="30 Days Customer Support"
      subtitle="Comprehensive post-launch support to ensure your success"
      description="Get 30 days of dedicated support after your project launch. Our team provides training, troubleshooting, and optimization to ensure your team is confident and your system is performing at its best. We're committed to your long-term success."
      features={features}
      heroImage="https://images.pexels.com/photos/3184465/pexels-photo-3184465.jpeg?auto=compress&cs=tinysrgb&w=1920"
    />
  )
}

export default CustomerSupport